// Dodanie wiadomości do wątku czatu

import { orionAxios } from '../orionApi';
import { AddMessageRequest } from './orionTypes';

/**
 * Wysyła wiadomość użytkownika do asystenta AI
 * @param threadId - UUID wątku
 * @param assistant - nazwa asystenta (np. "Test WiseB2B")
 * @param data - wiadomość i parametry URL (np. session_id dla autoryzacji)
 */
export const addMessage = async (
  threadId: string,
  assistant: string,
  data: AddMessageRequest
): Promise<void> => {
  await orionAxios.post(
    `/api/aiassistant/add-message/${threadId}/${encodeURIComponent(assistant)}`,
    data
  );
};

